import React from "react";
import {HeaderLayout} from "./HeaderLayout.jsx";
import {AppBar} from '@progress/kendo-react-layout';
import MainNavBar from "./components/MainNavBar/MainNavBar.jsx";

export const Header = (props) => {

    return (
        <HeaderLayout>
            <AppBar themeColor="primary">
                <MainNavBar />
            </AppBar>
        </HeaderLayout>
    )
}